import USAFlag from 'assets/svg/united_states_circle.svg';
import NetherlandFlag from 'assets/svg/europe_circle.svg';
import SingaporeFlag from 'assets/svg/south_east_asia_circle.svg';
import USAMap from 'assets/svg/map_united_states.png';
import NetherlandMap from 'assets/svg/map_europe.png';
import SingaporeMap from 'assets/svg/map_south_east_asia.png';

export const getRegionImage = (name) => {
  switch (name) {
    case 'united states':
      return USAFlag;
    case 'us':
      return USAFlag;
    case 'netherlands':
      return NetherlandFlag;
    case 'singapore':
      return SingaporeFlag;
    default:
      return '';
  }
};

export const getMapImage = (name) => {
  switch (name) {
    case 'united states':
      return USAMap;
    case 'us':
      return USAMap;
    case 'netherlands':
      return NetherlandMap;
    case 'singapore':
      return SingaporeMap;
    default:
      return USAMap;
  }
};
